import { useMemo } from "react";
// api
import { useQueryTransactionRecordAllowedQuery } from "src/api";
// routes
import { paths } from "src/routes/paths";
// components
import Image from "src/components/image";

// ----------------------------------------------------------------------

const icon = (name) => (
    <Image src={ `/assets/icon/navbar/${ name }.svg` } sx={ { width: 1, height: 1 } } disabledEffect visibleByDefault />
);

const ICONS = {
    dashboard: icon("ic_dashboard"),
    api: icon("ic_api"),
    shipments: icon("ic_shipments"),
    settings: icon("ic_settings"),
    //
    orders: icon("ic_orders"),
    reports: icon("ic_reports"),
    analytics: icon("ic_analytics"),
    packing: icon("ic_packing"),
    inventory: icon("ic_inventory"),
    warehouse: icon("ic_warehouse"),
    stores: icon("ic_stores"),
    wallet: icon("ic_wallet"),
    shipping_rules: icon("ic_shipping_rules"),
    address_book: icon("ic_address_book"),
    carrier_accounts: icon("ic_carrier_accounts"),
    user: icon("ic_user")
};

// ----------------------------------------------------------------------

export function useNavData() {
    const { data: canViewTransactionHistory } = useQueryTransactionRecordAllowedQuery(undefined, {
        refetchOnMountOrArgChange: true
    });

    return useMemo(() => [ {
        items: [
            {
                title: "Dashboard", path: paths.dashboard.home, icon: ICONS.dashboard
            },
            {
                title: "API SET-UP", path: paths.dashboard.api.root, icon: ICONS.api,
                children: [
                    { title: "API Keys", path: paths.dashboard.api.key.root },
                    { title: "Webhooks", path: paths.dashboard.api.webhook.root }
                ]
            },
            {
                title: "shipping", path: paths.dashboard.shipments.root, icon: ICONS.shipments,
                children: [
                    { title: "shipments", path: paths.dashboard.shipments.label.root },
                    { title: "pickups", path: paths.dashboard.shipments.pickup.root },
                    { title: "scan form", path: paths.dashboard.shipments.scanForm.root }
                ]
            },
            {
                title: "settings", path: paths.dashboard.settings.root, icon: ICONS.settings,
                children: [
                    { title: "profile", path: paths.dashboard.settings.profile.root },
                    { title: "billing", path: paths.dashboard.billing.root },
                    ...(canViewTransactionHistory
                        ? [ { title: "transaction history", path: paths.dashboard.settings.transaction_history.root } ]
                        : []),
                    { title: "carriers", path: paths.dashboard.settings.carriers.root }
                ]
            }
        ]
    } ], [ canViewTransactionHistory ]);
}
